import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { BuyFlowUser } from "features/types";
interface InitialState {
  newMembers: BuyFlowUser[];
  skipAddingPlans: boolean;
}

const initialState: InitialState = {
  newMembers: [],
  skipAddingPlans: false,
};
const addMembershipFlowSlice = createSlice({
  name: "addMembershipFlow",
  initialState,
  reducers: {
    setNewMembers: (state, action: PayloadAction<BuyFlowUser[]>) => {
      state.newMembers = action.payload;
    },
    addMember: (state, action: PayloadAction<BuyFlowUser>) => {
      state.newMembers.push(action.payload);
    },
    editMember: (
      state,
      action: PayloadAction<{ index: number; member: BuyFlowUser }>
    ) => {
      state.newMembers[action.payload.index] = action.payload.member;
    },
    deleteMember: (state, action: PayloadAction<number>) => {
      state.newMembers.splice(action.payload, 1);
    },
    setSkipAddingPlans: (state, action: PayloadAction<boolean>) => {
      state.skipAddingPlans = action.payload;
    },
    resetAddMembershipFlow: () => initialState,
  },
});

export const {
  setNewMembers,
  addMember,
  editMember,
  deleteMember,
  setSkipAddingPlans,
  resetAddMembershipFlow,
} = addMembershipFlowSlice.actions;

export default addMembershipFlowSlice.reducer;
